import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { EUR } from "../../../Currency/Currencies/EUR";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import  ReadinessStatusContainer from "../../../Entity/Entities/FinancialStatement/ReadinessStatus/ReadinessStatusContainer";
import {
  Card,
  TableCell,
  TableRow,
  Button,
  FormControlLabel,
  Checkbox,
  Switch
} from '@material-ui/core';
import { SnoozeDialog } from "../../Partials/Dialog/SnoozeDialog";
import { FinancialStatementInterface } from "Casadesk/Entity/Entities/FinancialStatement/FinancialStatementInterface";
import Time from "../../../Time/Time";
import Memo from "../../Partials/Memo/Memo";
import * as ReactTooltip from 'react-tooltip'
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import CasedeskUrl from "../../../Url/Url";
import DashboardStatementsWillMount from "../../../Middleware/Middlewares/DashboardStatementsWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";

class Statements extends Component {
  protected statementsFilter: string = "notSent";
  protected paginatorPath: string = !!this.props.app.statementsFilterSearchState ?
                                    `Statements_${this.props.app.statementsFilterState}_${this.props.app.statementsFilterSearchState}` :
                                    `Statements_${this.props.app.statementsFilterState || this.statementsFilter}`;

  protected userId: number = this.props.app.session.user.id;

  protected middlewares: MiddlewareInterface[] = [
    DashboardStatementsWillMount
  ];

  public state = {
    currentStatement: null,
    statements: [],
    notSentStatements: [],
    statementsCount: 0,
    notSentStatementsCount: 0,
    filter: this.props.app.statementsFilterState || this.statementsFilter,
    isSaving: false,
    anchorEl: null,
    isFetching: true,
    filterValue: this.props.app.statementsFilterSearchState || "",
    nextPath: "",
    includeSnoozedFilter: false,
    languageForPdf: this.props.app?.settings?.agency?.defaultLocale?.iso === "en-US" ? 1 : 2,
    snoozeStatementDialogOpen: false,
    selectedStatement: null,
    memoPopupOpen: false,
    statementToAddNote: null,
    notSentSnoozedStatementsCount: null
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (!this.props?.financialStatements?.requestsOutdated && nextProps?.financialStatements?.requestsOutdated) {
      this.fetchFirstNotSentStatements();
    }
  }

  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public fetchFirstNotSentStatements = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      sortBy: "+firstDate",
      offset: 0,
      limit: paginationAmount,
      filterValue: this.state.filterValue,
      removed: 0,
      isSent: Number(false),
      afterInvoiceNumberStartDate: true,
      isSnoozed: this.state.includeSnoozedFilter ? 1 : 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.fetchFirstNotSentSnoozedStatementsCount();

        if (!this.state.includeSnoozedFilter) {
          this.props.dispatch({
            type: Constants.GLOBAL_SAVE_NOTSENT_STATEMENTS_COUNT,
            payload: {
              dashboardStatementsCount: data.count
            }
          })
        } else {
          this.props.dispatch({
            type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
            payload: {
              ...payload,
              isSnoozed: 0
            },
            onSuccess: (data) => {
              this.props.dispatch({
                type: Constants.GLOBAL_SAVE_NOTSENT_STATEMENTS_COUNT,
                payload: {
                  dashboardStatementsCount: data.count
                }
              })
            }
          });
        }

        this.setState({
          notSentStatements: data.financialStatements,
          notSentStatementsCount: data.count,
          isFetching: false
        }, () => {
          if (typeof callback === "function") {
            callback();
          }
        });
      }
    });
  }

  public fetchFirstNotSentSnoozedStatementsCount = () => {
    const payload: any = {
      sortBy: "+firstDate",
      offset: 0,
      limit: 0,
      filterValue: this.state.filterValue,
      removed: 0,
      isSent: Number(false),
      afterInvoiceNumberStartDate: true,
      isSnoozed: 1
    };

    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_NOT_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.setState({
          notSentSnoozedStatementsCount: data.count,
          isFetching: false
        });
      },
      onError: () => {
        this.setState({
          isFetching: false
        });
      }
    });
  }

  public fetchFilterNotSentStatements = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
      payload: {
        sortBy: "+firstDate",
        filterValue: this.state.filterValue,
        removed: 0,
        isSent: Number(false),
        afterInvoiceNumberStartDate: true
      },
      onSuccess: (data) => {
        this.setState({
          notSentStatements: data.financialStatements,
          notSentStatementsCount: data.count,
          isFetching: false
        });
      }
    });
  }

  public clearFilterNotSentStatements = () => {
    // this.props.dispatch({
    //   type: Constants.STATEMENTS_FILTER_SEARCH_UPDATE_STATE,
    //   payload: {
    //     filter: ""
    //   }
    // });

    this.setState({
      filterValue: ""
    }, this.fetchFirstNotSentStatements);
  }

  protected onEnter = (event): any => {
    if (event.key === "Enter") {
      this.paginatorPath = !!this.state.filterValue ?
                              `Statements_${this.state.filter}_${this.state.filterValue}` :
                              `Statements_${this.state.filter}`;

      // this.props.dispatch({
      //   type: Constants.STATEMENTS_FILTER_SEARCH_UPDATE_STATE,
      //   payload: {
      //     filter: this.state.filterValue
      //   }
      // });

      if (this.state.filter === "notSent") {
        this.fetchFirstNotSentStatements();
      }
    }
  }

  public setFilterValue = (event): any => {
    this.setState({
      filterValue: event.target.value
    } ,() => {
      if (this.state.filterValue === "") {
        if (this.state.filter === "notSent") {
          this.fetchFirstNotSentStatements();
        }
      }
    });
  }

  public fetchStatements = () => {
    if (this.state.filter === "notSent") {
      const payload: any = {
        sortBy: "+firstDate",
        offset: !!this.state.notSentStatements ?  this.state.notSentStatements.length : 0,
        limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        removed: 0,
        isSent: Number(false),
        afterInvoiceNumberStartDate: true
      };

      if (!this.state.includeSnoozedFilter) {
        payload.isSnoozed = 0;
      }

      
      this.props.dispatch({
        type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const notSentStatementsArr = !!this.state.notSentStatements ?
                                          [...this.state.notSentStatements, ...data.financialStatements] : [...data.financialStatements];

          this.setState({
            notSentStatements: notSentStatementsArr,
            notSentStatementsCount: data.count,
            isFetching: false
          });
        }
      });
    }
  }

  public getAmountsOfFilteredStatements = (filter: string): number => {
    switch (filter) {
      case "notSent":
        return this.state.notSentStatementsCount;
      default:
        return;
    }
  }

  public getFilteredStatements = (filter: string) => {
    switch (filter) {
      case "notSent":
        return this.state.notSentStatements;
      default:
        return;
    }
  }

  protected openMenu = (event: any, statement): void => {
    this.setState({
      currentStatement: statement,
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public changeIncludeSnoozedFilter = () => {
    this.setState({
      includeSnoozedFilter: !this.state.includeSnoozedFilter
    }, () => {
      this.fetchFirstNotSentStatements();
    });

    this.props.dispatch({
      type: Constants.PAGE_STATEMENT_LIST_CHECK_FILTER,
      payload: {
        includeSnoozedFilter: !this.state.includeSnoozedFilter,
      }
    });
  }

  public download = (chargeId: number): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_FINANCIAL_STATEMENT_DOWNLOAD_START,
        payload: {
          chargeId: chargeId,
          language: this.state.languageForPdf
        },
        onSuccess: url => {
          window.open(CasedeskUrl.getAttachment(url), "_blank");

          this.setState({
            isSaving: false,
            previewTypeOfPdf: false
          })
        },
        onError: () => {
          this.setState({
            isSaving: false,
            previewTypeOfPdf: false
          })
        }
      });
    })
  }

  public changeReadinessStatus = (statement) => {
    const readinessStatusIdToSet = statement?.readinessStatusId === 
                                   ReadinessStatusContainer.pickIdFromLabel("ReadyToSend") ?
                                     ReadinessStatusContainer.pickIdFromLabel("ReadyForReview") :
                                     ReadinessStatusContainer.pickIdFromLabel("ReadyToSend");
                                     
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_START,
        payload: {
          statementId: statement?.id,
          readinessStatusId: readinessStatusIdToSet
        },
        onSuccess: () => {
          this.fetchFirstNotSentStatements(() => {
            this.setState({
              statementToAddNote: this.state.notSentStatements.find(finStatement => statement?.id === finStatement?.id)
            })
          });

          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public saveScrollPosition = () => {
    var top  = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.DASHBOARD_STATEMENTS_LIST_POSITION_SAVE,
      payload: {
        position: top
      }
    });
  }

  public getStatements = () => {
    return this.getFilteredStatements(this.state.filter)
      .map((statement, index: number) => {
        const owner = statement?.owner;

        // TODO: rewrite this part
        const properties = owner.properties;

        let propertyStreetDetailsFirst;
        let propertyStreetDetailsSecond;
        let propertyStreetDetailsThird;

        if(properties[0]){
          propertyStreetDetailsFirst  =  properties[0]?.address?.route ? `${properties[0].address.route}` : properties[0]?.address?.formattedAddress;
        }
        if(properties[1]){
          propertyStreetDetailsSecond =  properties[1]?.address?.route ? `${properties[1].address.route}` : properties[1]?.address?.formattedAddress;
        }
        if(properties[2]){
          propertyStreetDetailsThird  =  properties[2]?.address?.route ? `${properties[2].address.route}` : properties[2]?.address?.formattedAddress;
        }

        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => {
              this.saveScrollPosition();
              this.redirect(`/app/owner-statement/update/${statement.id}`)
            }}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "0px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  className="icon icon-ic-finances"
                  style={{
                    color: "rgb(0, 188, 212)"
                  }}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{width: "14%"}}>{this.formatter.monthYearFormatDate(statement.firstDate)}</TableCell>
            <TableCell style={{width: "18%"}}>{owner?.displayName}</TableCell>
            <TableCell style={{width: "18%"}}>{`${propertyStreetDetailsFirst ? `${propertyStreetDetailsFirst}` : ""} ${propertyStreetDetailsSecond ? `, ${propertyStreetDetailsSecond}`: ""} ${propertyStreetDetailsThird ? `, ${propertyStreetDetailsThird}`: ""}`}</TableCell>
            <TableCell style={{width: "14%"}}>
              {
                <div
                  style={{
                    display: "flex", justifyContent: "flex-start", flexWrap: "wrap"
                  }}
                >
                  {
                    statement?.isSnoozed && (
                      <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div className="list-label creation-type-label">
                          {this.trans("label-snoozed")}
                        </div>
                      </div>
                      
                    )
                  }
                  {
                    !statement?.isSent && (
                      <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div className="list-label creation-type-label">
                          {this.trans("label-not-sent")}
                        </div>
                      </div>
                      
                    )
                  }
                  {
                    statement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyForReview") ? 
                    <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                      {
                        this.props.app?.settings?.agency?.reviewOwnerStatements &&
                        <div className="list-label creation-type-label orange">
                          {this.trans("statement-status/ready-for-review")}
                      </div> 
                      }
                    </div>
                    :
                    statement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyToSend") &&
                    <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                      {
                        this.props.app?.settings?.agency?.reviewOwnerStatements &&
                        <div className="list-label creation-type-label green">
                          {this.trans("statement-status/ready-to-send")}
                        </div>
                      }
                  </div>
                  }
                </div>
              }
            </TableCell> 
            <TableCell style={{width: "2%"}}>
              <div 
                className="icon icon-ic-pdf aligned"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.download(statement?.actualPayoutChargeId)
                }}
              ><span className="path1 icon-ic-pdf"></span><span className="path2 icon-ic-pdf"></span><span className="path3 icon-ic-pdf"></span></div>
            </TableCell>
            <TableCell style={{width: "18%"}}>
              {
                (statement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyForReview") || 
                statement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyToSend")) && 
                this.props.app?.settings?.agency?.reviewOwnerStatements && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={statement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyToSend")}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        onChange={() => this.changeReadinessStatus(statement)}
                        color="primary"
                      />
                      }
                    label={this.trans("statement-status/ready-to-send")}
                  />
                )
              }
            </TableCell> 
            <TableCell style={{width: "2%"}}>
              {this.renderStatementSnoozeIcon(statement)}
            </TableCell>
            <TableCell style={{width: "2%"}}>
              {console.log("statement", statement)}
              {this.renderStatementMemoIcon(statement)}
            </TableCell>
            <TableCell style={{width: "12%"}}>
              {this.formatter.formatNumber(statement?.payoutSection ? statement?.payoutSection?.result : statement?.result, new EUR())}
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderStatementSnoozeIcon = (statement: FinancialStatementInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <div className={`icon ${statement?.isSnoozed ? "icon-ic-schedule" : "icon-ic-watch-later" }`}
          onClick={e => {
            e.stopPropagation();

            if (statement?.isSnoozed) {
              this.snoozeStatement(statement);
            } else {
              this.setState({
                snoozeStatementDialogOpen: true,
                selectedStatement: statement
              })
            }
          }}
        >
        </div>
      </div>
    );
  }

  public snoozeStatement = (statement: FinancialStatementInterface) => {
    if(!statement) {
      return;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_STATEMENT_SNOOZE_UPDATE_START,
        payload: {
          snoozeDate: !statement.isSnoozed ? Time.formatOrNull(Time.nextDayFromDate(new Date())) : null,
          statementId: statement?.id
        },
        onSuccess: () => {
          this.setState({
            anchorEl: null,
            isSaving: false,
          }, () => {
            this.fetchFirstNotSentStatements();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public renderStatementMemoIcon = (statement: FinancialStatementInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <span>
        {console.log(statement)}
          {/* <span data-tip={this.getTipText(statement?.note)}> */}
          <div className={`icon ${statement?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(statement);
              }}
            >
            </div>
          {/* </span> */}
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  }

  public openMemoPopup = (statement: FinancialStatementInterface) => {
    this.setState({
      statementToAddNote: statement,
      memoPopupOpen: true, 
      anchorEl: null 
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs bottom-whitespace ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={2}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "48px",
                  maxHeight: "48px"
                }}
              >
                <h3 className="card-title" style={{flexDirection: "column", display: "flex"}}>
                  {this.trans("title-statements-dashboard")}
                  <span onClick={() => this.redirect("/app/finance/owner-statements")} style={{top: `${this.props.app?.settings?.agency?.reviewOwnerStatements ? "60px" : "35px"}`}} className="dashboard-link-title">{this.trans("link-to-all-statements")}</span>

                  <h4 className="dashboard-subtitle">{this.trans("dashboard-statements/subtitle")}</h4>
                </h3>
                <div className="button-container">
                  {this.props.app?.settings?.agency?.reviewOwnerStatements &&
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => this.redirect(`/app/email/send/statements-request-review`)}
                    >
                      {this.trans("page/dashboard-tab/statements-button/requeststatementsreview")}
                    </Button>
                  }
                </div>
              </div>

              <div>
                <div>
                  <div
                    className="list-filters-wrapper"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.includeSnoozedFilter}
                          onChange={this.changeIncludeSnoozedFilter}
                          color="primary"
                        />
                      }
                      label={`${this.trans("label-include-snoozed-statements")} ${this.state.notSentSnoozedStatementsCount > 0 ? `(${this.state.notSentSnoozedStatementsCount})` : ""}`}
                    />
                      {/* <TextField
                        autoComplete="off"
                        type="text"
                        style={{color: "rgb(0, 188, 212)"}}
                        label={this.trans("label-search")}
                        value={this.state.filterValue}
                        onChange={this.setFilterValue}
                        onKeyPress={this.onEnter}
                        variant="standard"
                        error={false}
                      />
                      { this.state.filterValue !== "" &&
                        <div className="icon icon-ic-close clear-button clear-button-search" onClick={this.state.filter === "all" ? this.clearFilterAllNotes : this.clearFilterOpenNotes}></div>
                      } */}
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table statements-listing-table with-first-border not-3-dot"
                  headers={[
                    "", this.trans("label-period"), this.trans("owner"), this.trans("title-properties"), "", "", "", "", "", this.trans("result")
                  ]}
                  rows={this.getStatements()}
                  rowsLength={this.getAmountsOfFilteredStatements(this.state.filter)}
                  subtitle={this.trans("title-no-statements-to-list")}
                  fetch={this.fetchStatements}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>

        <SnoozeDialog 
          {...this.props}
          entity={this.state.selectedStatement}
          isOpen={this.state.snoozeStatementDialogOpen}

          fetchFirstNotSentStatements={() => this.fetchFirstNotSentStatements()}
          closeDialog={() => {
            this.setState({
              snoozeStatementDialogOpen: false,
              isSaving: false, 
              anchorEl: null
            })
          }}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo 
                {...this.props}
                relations={{ financialStatementId: this.state.statementToAddNote?.id }}
                fetchEntities={() => {
                  this.props.dispatch({
                    type: Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS
                  });

                  this.fetchFirstNotSentStatements();
                }}
                additionalElement={
                  (this.state.statementToAddNote?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyForReview") || 
                  this.state.statementToAddNote?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyToSend")) ?
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.statementToAddNote?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyToSend")}
                            onClick={e => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                            onChange={() => this.changeReadinessStatus(this.state.statementToAddNote)}
                            color="primary"
                          />
                          }
                        label={this.trans("statement-status/ready-to-send")}
                      />
                  :
                  null
                }
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({memoPopupOpen: false})}
          hideCross={true}
          subtitle={`${this.formatter.monthYearFormatDate(this.state.statementToAddNote?.firstDate)}, ${this.state.statementToAddNote?.owner?.displayName}`}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    units: state.units,
    component: state.statements,
    globalTypes: state.globalTypes,
    financialStatements: state.financialStatements,
  };
};

export default connect(mapStateToProps)(Statements);
